import * as Sentry from "@sentry/browser"

const meta = (name) => document.querySelector(`meta[name="${name}"]`)?.content

const dsn = meta("sentry-dsn")

// The pages show children's and parents' data, and SDK 11 collects cookies,
// user/IP, headers, bodies and query strings unless told not to.
if (dsn) {
  Sentry.init({
    dsn,
    environment: meta("sentry-environment"),
    dataCollection: {
      userInfo: false,
      cookies: false,
      httpHeaders: false,
      httpBodies: [],
      urlQueryParams: false
    }
  })
}
